function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2962 6.39117H22.5454V3.57572H23.2962C23.6849 3.57572 24 3.26058 24 2.87184C24 2.48311 23.6849 2.16797 23.2962 2.16797H5.65725C4.1048 2.16797 2.8418 3.43097 2.8418 4.98342C2.8418 6.53588 4.1048 7.79888 5.65725 7.79888H6.3623V5.68978C6.3623 5.30105 6.67744 4.98591 7.06617 4.98591H11.273C11.6617 4.98591 11.9768 5.30105 11.9768 5.68978V7.79888C12.7167 7.79925 22.1675 7.80717 23.2962 7.79888C23.6849 7.79888 24 7.48373 24 7.095C24 6.70631 23.6849 6.39117 23.2962 6.39117Z",
  fill: "#7C818C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5691 8.55542V6.39453H7.77002V8.5423C8.21491 8.28406 8.52086 7.89847 9.15424 7.89847C9.784 7.89847 10.0875 8.27881 10.5691 8.55542Z",
  fill: "#7C818C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2962 17.607C23.6849 17.607 24 17.2918 24 16.9031C24 16.5144 23.6849 16.1992 23.2962 16.1992C22.1103 16.1992 18.7995 16.1992 17.6124 16.1992V16.95C17.6124 17.508 16.9896 17.8479 16.5199 17.5369L14.7899 16.3912L13.0952 17.5337C12.6321 17.8459 11.9979 17.5162 11.9979 16.95V16.1992H5.65725C4.1048 16.1992 2.8418 17.4622 2.8418 19.0147C2.8418 20.5671 4.1048 21.8301 5.65725 21.8301H23.2962C23.6849 21.8301 24 21.515 24 21.1262C24 20.7375 23.6849 20.4224 23.2962 20.4224H22.5454V17.6069H23.2962V17.607Z",
  fill: "#7C818C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9979 12.6904C11.9979 12.3017 12.313 11.9865 12.7018 11.9865H16.9086C17.2973 11.9865 17.6124 12.3017 17.6124 12.6904V14.795H18.3428C19.8953 14.795 21.1583 13.532 21.1583 11.9795C21.1583 10.4271 19.8953 9.16406 18.3428 9.16406H11.9768V9.86794C11.9768 10.428 11.3516 10.7647 10.8838 10.4545L9.15422 9.30717L7.46002 10.4513C6.9968 10.7641 6.36225 10.434 6.36225 9.86794V9.16406H0.703875C0.315141 9.16406 0 9.4792 0 9.86794C0 10.2567 0.315141 10.5718 0.703875 10.5718H1.45467V13.3873H0.703875C0.315141 13.3873 0 13.7024 0 14.0911C0 14.4799 0.315141 14.795 0.703875 14.795C0.878812 14.795 9.10758 14.7959 11.9979 14.795V12.6904Z",
  fill: "#7C818C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.79 14.9832C15.4195 14.9832 15.7229 15.3631 16.2048 15.6395V13.3906H13.4058V15.6265C13.8524 15.3675 14.1572 14.9832 14.79 14.9832Z",
  fill: "#7C818C"
});

var SvgMasterTryOut = function SvgMasterTryOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMasterTryOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/master-try-out.c502080e.svg";
export { ForwardRef as ReactComponent };